import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {BranchModel} from "../../models/branch.model";

export class branchActiveDeliveriesCtrl implements IController {

  branch: BranchModel;
  agents: any;

  private loadLimit = 20;
  private deliveriesRef: any;
  private selectedAgent: any;
  private disableTimeSettings: any;
  private defaultGroup: any;
  private groupList: any;
  private filterConfig: any;
  private range: any;
  private infiniteScroll: any;

  /* @ngInject */
  constructor(private $log, private $deliveries, private deliveriesConstants,
              private $infiniteScroll, private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private moment) {
  }

  $onInit() {
    this.deliveriesRef = this.$deliveries();
    this.range = this.dateRangeTimeFiltersService.thisMonth();

    this.selectedAgent = null;
    this.disableTimeSettings = this._getTimeSettingsAvailability(this.range);
    this.defaultGroup = this.deliveriesConstants.group.Finished;
    this.groupList = [
      this.deliveriesConstants.group.Canceled,
      this.deliveriesConstants.group.Completed,
      this.deliveriesConstants.group.ManualHandled
    ];

    this.filterConfig = {
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      range: this.range,
      group: undefined,
      status: undefined,
      queryString: undefined,
      timeWindow: undefined,
      dateForTimeSlots: undefined
    };

    this.deliveriesRef.$query(this._qetQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.deliveriesRef, this.loadLimit);
  }

  // ******************************
  //        Public methods
  // ******************************

  submitQuery(queryString) {
    this.filterConfig.queryString = queryString;
    this._query();
  }

  rangeChanged(range) {
    if (!_.isUndefined(range) && !_.isEqual(range.name, this.filterConfig.range.name)) {
      this.filterConfig.range = range;
      this.disableTimeSettings = this._getTimeSettingsAvailability(range);
      if (!this.disableTimeSettings) {
        this.filterConfig.dateForTimeSlots = angular.copy(range.dateStart);
      }
    }
  }

  onTimeWindowChange(timeWindow) {
    this.filterConfig.timeWindow = timeWindow;
    this.filterConfig.range = this._getRange(this.filterConfig.range, timeWindow);
    this._query();
  }

  onGroupChanged(group) {
    // ctrl.filterConfig.group = group === deliveriesConstants.group.ManualHandled ? undefined : group;
    this.filterConfig.group = group;
    this.filterConfig.status = group === this.deliveriesConstants.group.ManualHandled ? group : undefined;
    this._query();
  }

  onSelectAgent(agent) {
    this.selectedAgent = agent;
    this._query();
  }

  // ******************************
  //        Private methods
  // ******************************

  _getRange(range, timeWindow) {
    if (timeWindow) {
      return {
        dateStart: this.moment(range.dateStart).hour(_.get(timeWindow, 'fromHour')).minute(_.get(timeWindow, 'fromMinute')).seconds(0).millisecond(0).valueOf(),
        dateEnd: this.moment(range.dateEnd).hour(_.get(timeWindow, 'toHour')).minute(_.get(timeWindow, 'toMinute')).seconds(0).millisecond(0).valueOf()
      }
    } else {
      return {
        dateStart: this.moment(this.filterConfig.range.dateStart).startOf('day').valueOf(),
        dateEnd: this.moment(this.filterConfig.range.dateEnd).endOf('day').valueOf()
      };
    }
  }

  _getTimeSettingsAvailability(range) {
    let dateStart = this.moment(range.dateStart).format("MM/DD/YYYY"),
      dateEnd = this.moment(range.dateEnd).format("MM/DD/YYYY");

    // Disable TIME picker if its not the same date.
    return !_.isEqual(dateStart, dateEnd);
  }

  _query() {
    this.deliveriesRef.$query(this._qetQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      }, (resp) => {
        this.$log.debug('Fail to $query', resp);
      });
  }

  _qetQueryPayload() {
    let group = this.filterConfig.group === this.deliveriesConstants.group.ManualHandled ? undefined : this.filterConfig.group;
    return {
      branchIds: [this.branch.id],
      // accountId:      ctrl.isDemand ? ctrl.account.id : undefined,
      agentIds: _.get(this.selectedAgent, 'id') ? [this.selectedAgent.id] : undefined,
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      group: group || this.defaultGroup,
      status: this.filterConfig.status,
      query: this.filterConfig.queryString,
      limit: this.loadLimit
    };
  }
}

angular
  .module('bringoz.admin.branches')
  .component('branchDeliveryHistory', {
    bindings: {
      branch: '<',
      agents: '<'
    },
    template: require('./branch-delivery-history.html').default,
    controller: branchActiveDeliveriesCtrl
  });
